import React from 'react';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {solid} from "@fortawesome/fontawesome-svg-core/import.macro";
import PermissionsGate from "@/Shared/PermissionsGate";
import {useDispatch} from "react-redux";
import {openModal} from "@/Store/Slices/ModalSlice";
import {InertiaLink} from "@inertiajs/inertia-react";

const PublicMerchantActionBtns = ({link, id, showonline}) => {
  const dispatch = useDispatch();

  const handleUnpublished = () => {
    dispatch(openModal({
        modalType: 'merchant-unpublication',
        modalProps: {
          id: id
        }
      }
    ));
  }

  return (
    <div className='flex'>
      <a target='_blank' className={'mr-3'} id="tooltip" data-tip="Go to the store site" href={link}>
        <FontAwesomeIcon
          color={'blue'}
          size={'lg'}
          icon={solid('arrow-up-right-from-square')}/>
      </a>
      {
        showonline === 1 ? (
          <InertiaLink data-tip="Hide merchant" href={route('public.merchants.hide', id)}>
            <FontAwesomeIcon
              rotation={180}
              color={'gray'}
              size={'lg'}
              icon={solid('eye-slash')}/>
          </InertiaLink>
        ) : (
          <InertiaLink data-tip="Show merchant" href={route('public.merchants.show', id)}>
            <FontAwesomeIcon
              rotation={180}
              color={'blue'}
              size={'lg'}
              icon={solid('eye')}/>
          </InertiaLink>
        )
      }
      <InertiaLink className={'ml-3'} data-tip="Unpublish merchant" href={route('public.merchants.unpublished', id)}>
        <FontAwesomeIcon
          rotation={180}
          color={'red'}
          size={'lg'}
          icon={solid('arrow-right-long')}/>
      </InertiaLink>

    </div>
  );
};

export default PublicMerchantActionBtns;
